import React from 'react';
import MonthlyPerformanceTable from './MonthlyPerformanceTable';
import { TimePeriod } from '../../types/api';

interface SalesParametersTableProps {
  branchId?: number;
  currency?: string;
  timeRange?: TimePeriod;
}

const SalesParametersTable: React.FC<SalesParametersTableProps> = ({ branchId, currency, timeRange }) => {
  return (
    <MonthlyPerformanceTable
      branchId={branchId}
      currency={currency}
      timeRange={timeRange}
      dashboardSource="club"
      title="پارامترهای فروش"
      visibleColumns={[
        'month',
        'subscription',
        'invoiceCount',
        'invoiceCountGrowth',
        'totalAmount',        
        'totalAmountGrowth',
        'avgInvoice',
        'avgItemPrice',
        'priceGrowth',
        'avgItemCount',        
        'basketGrowth'
      ]}
    />
  );
};

export default SalesParametersTable;
